import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { SubEntityType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { SUBENTITIES, GET_SUBENTITIES_BY_ID_ENTITY} from "../../utils/constants";

export const createSubEntity = async (data: SubEntityType) => await post<SubEntityType, string>(SUBENTITIES, data);
export const updateSubEntity = async (data: SubEntityType) => await put<SubEntityType, string>(SUBENTITIES, data);

export const getSubEntities = async (data?: PagedRequestType) => {
    debugger;
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        
    });
    const url = `${SUBENTITIES}?${queryParams.toString()}`;
    return await get<PagedResultsType<SubEntityType>>(url)
};

export const getSubEntitiesByIdEntity = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdEntity ? { IdEntity: data.IdEntity  } : {}),
    });
    const url = `${GET_SUBENTITIES_BY_ID_ENTITY}?${queryParams.toString()}`;
    return await get<PagedResultsType<SubEntityType>>(url);
};